/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Timesheet controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, TimesheetDetail, UpdateTimesheetRequest, UpdateTimesheetStateRequest, GetTravelDistanceResponse, BillingTimesheetState, GetTimesheetsResponse, CreateTimesheetRequest, CreateTimesheetResponse, GetTimesheetDocumentsResponse, AttachTimesheetDocumentResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TimesheetService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTimesheetById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TimesheetDetail>;
    getTimesheetById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TimesheetDetail>>;
    getTimesheetById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TimesheetDetail>>;
    getTimesheetById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateTimesheet(id: number, updateTimesheetRequest: UpdateTimesheetRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateTimesheet(id: number, updateTimesheetRequest: UpdateTimesheetRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateTimesheet(id: number, updateTimesheetRequest: UpdateTimesheetRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateTimesheet(id: number, updateTimesheetRequest: UpdateTimesheetRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateTimesheetRequest, requestOptions);
    }

    deleteTimesheet(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTimesheet(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTimesheet(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTimesheet(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    updateTimesheetState(id: number, updateTimesheetStateRequest: UpdateTimesheetStateRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateTimesheetState(id: number, updateTimesheetStateRequest: UpdateTimesheetStateRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateTimesheetState(id: number, updateTimesheetStateRequest: UpdateTimesheetStateRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateTimesheetState(id: number, updateTimesheetStateRequest: UpdateTimesheetStateRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/${id}/state`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateTimesheetStateRequest, requestOptions);
    }

    getTravelDistance(customerId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTravelDistanceResponse>;
    getTravelDistance(customerId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTravelDistanceResponse>>;
    getTravelDistance(customerId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTravelDistanceResponse>>;
    getTravelDistance(customerId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/travel-distance/${customerId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getTimesheets(concernIds: Array<number>, createdByIds: Array<number>, timesheetTypeIds: Array<number>, statusIds: Array<number>, todoIds: Array<number>, searchTerm?: string | null, isBillable?: boolean | null, billingTimesheetState?: (Array<BillingTimesheetState> | null), startDate?: Date | null, endDate?: Date | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetsResponse>;
    getTimesheets(concernIds: Array<number>, createdByIds: Array<number>, timesheetTypeIds: Array<number>, statusIds: Array<number>, todoIds: Array<number>, searchTerm?: string | null, isBillable?: boolean | null, billingTimesheetState?: (Array<BillingTimesheetState> | null), startDate?: Date | null, endDate?: Date | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetsResponse>>;
    getTimesheets(concernIds: Array<number>, createdByIds: Array<number>, timesheetTypeIds: Array<number>, statusIds: Array<number>, todoIds: Array<number>, searchTerm?: string | null, isBillable?: boolean | null, billingTimesheetState?: (Array<BillingTimesheetState> | null), startDate?: Date | null, endDate?: Date | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetsResponse>>;
    getTimesheets(concernIds: Array<number>, createdByIds: Array<number>, timesheetTypeIds: Array<number>, statusIds: Array<number>, todoIds: Array<number>, searchTerm?: string | null, isBillable?: boolean | null, billingTimesheetState?: (Array<BillingTimesheetState> | null), startDate?: Date | null, endDate?: Date | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }
        if (concernIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, concernIds, 'concernIds');
        }
        if (createdByIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, createdByIds, 'createdByIds');
        }
        if (timesheetTypeIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, timesheetTypeIds, 'timesheetTypeIds');
        }
        if (statusIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, statusIds, 'statusIds');
        }
        if (todoIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, todoIds, 'todoIds');
        }
        if (isBillable != null) {
            params = HttpParamsBuilder.addToHttpParams(params, isBillable, 'isBillable');
        }
        if (billingTimesheetState != null) {
            params = HttpParamsBuilder.addToHttpParams(params, billingTimesheetState, 'billingTimesheetState');
        }
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createTimesheet(createTimesheetRequest: CreateTimesheetRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateTimesheetResponse>;
    createTimesheet(createTimesheetRequest: CreateTimesheetRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateTimesheetResponse>>;
    createTimesheet(createTimesheetRequest: CreateTimesheetRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateTimesheetResponse>>;
    createTimesheet(createTimesheetRequest: CreateTimesheetRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createTimesheetRequest, requestOptions);
    }

    getTimesheetDocuments(timesheetId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTimesheetDocumentsResponse>;
    getTimesheetDocuments(timesheetId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTimesheetDocumentsResponse>>;
    getTimesheetDocuments(timesheetId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTimesheetDocumentsResponse>>;
    getTimesheetDocuments(timesheetId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/${timesheetId}/documents`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    attachTimesheetDocument(timesheetId: number, file: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<AttachTimesheetDocumentResponse>;
    attachTimesheetDocument(timesheetId: number, file: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<AttachTimesheetDocumentResponse>>;
    attachTimesheetDocument(timesheetId: number, file: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<AttachTimesheetDocumentResponse>>;
    attachTimesheetDocument(timesheetId: number, file: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/${timesheetId}/documents`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, formData, requestOptions);
    }

    deleteTimesheetDocument(timesheetId: number, documentId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTimesheetDocument(timesheetId: number, documentId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTimesheetDocument(timesheetId: number, documentId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTimesheetDocument(timesheetId: number, documentId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Timesheet/${timesheetId}/documents/${documentId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }
}
